/** Satırı şu an başkası düzenliyor: satır başında küçük avatar (title'da kim ve ne zamandan beri). */
import { useTranslation } from 'react-i18next';
import { Avatar } from '@/shared/ui/Avatar';
import type { PresenceUser } from '../model/presenceStore';
import { editorLabel, minutesAgo, useUserPhoto } from '../model/presenceHooks';

export function RowEditorBadge({ editors }: { editors: PresenceUser[] }) {
  const { t } = useTranslation();
  const first = editors[0]!;
  const photo = useUserPhoto(first.userId);
  const title = editors
    .map((u) => {
      const min = minutesAgo(u.editingSince);
      const name = editorLabel(u, t);
      return min > 0 ? t('presence.editingFor', { name, count: min }) : t('presence.editing', { name });
    })
    .join('\n');
  return (
    <span data-row-editor title={title} className="mr-1 inline-flex shrink-0 items-center">
      <Avatar
        name={first.userName || first.userCode}
        imageBase64={photo}
        className="h-4 w-4 text-[8px] ring-2 ring-amber-500"
      />
      {editors.length > 1 ? (
        <span className="ml-0.5 text-[10px] text-amber-600">+{editors.length - 1}</span>
      ) : null}
    </span>
  );
}
